// Hero images configuration
// Add image numbers as you add new hero images to /assets/images/
// Images should be named: hero_00.jpg, hero_01.jpg, etc.


    // Add more as you add images:
export const HERO_IMAGES = [
    0,  // hero_00.jpg
    1,  // hero_01.jpg
    2,
    3,
    4
];
